import React, { useState, useEffect } from 'react';
import './Cobrancas.css';

const CalendarioCobrancasModal = ({ show, onClose, cobrancas = [] }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  if (!show) return null;

  const meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const diasSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const isSameDay = (d1, d2) => {
    return d1.getDate() === d2.getDate() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getFullYear() === d2.getFullYear();
  };

  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);
    const today = new Date();
    
    const prevMonthDays = getDaysInMonth(year, month - 1);
    
    const cells = [];
    
    // Dias do mês anterior
    for (let i = firstDay - 1; i >= 0; i--) {
      cells.push(
        <div key={`prev-${i}`} className="calendar-cell disabled large">
          <span className="number">{prevMonthDays - i}</span>
        </div>
      );
    }
    
    // Dias do mês atual
    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d);
      const count = cobrancas.filter(c => isSameDay(new Date(c.vencimento), date)).length;
      const isSelected = isSameDay(date, selectedDate);
      const isToday = isSameDay(date, today);
      
      cells.push(
        <div 
          key={`current-${d}`} 
          className={`calendar-cell large ${isSelected ? 'selected' : ''} ${isToday ? 'today' : ''}`}
          onClick={() => setSelectedDate(date)}
        >
          <span className="number">{d}</span>
          {count > 0 && <span className="calendar-badge large">{count}</span>}
        </div>
      );
    }
    
    // Dias do próximo mês
    const totalCells = cells.length;
    for (let i = 1; i <= (42 - totalCells); i++) {
      cells.push(
        <div key={`next-${i}`} className="calendar-cell disabled large">
          <span className="number">{i}</span>
        </div>
      );
    }
    
    return cells;
  };

  return (
    <div className="modal-overlay-calendar">
      <div className="modal-calendar-container">
        <div className="modal-calendar-header">
          <div style={{ flex: 1 }}>
            <h2 style={{ margin: 0 }}>Calendário de Cobranças</h2>
          </div>
          
          <div className="calendar-nav" style={{ flex: 1, justifyContent: 'center', marginBottom: 0 }}>
            <button type="button" onClick={handlePrevMonth}>&lt;</button>
            <span style={{ minWidth: '200px', textAlign: 'center' }}>{meses[currentDate.getMonth()]} {currentDate.getFullYear()}</span>
            <button type="button" onClick={handleNextMonth}>&gt;</button>
          </div>

          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <button className="modal-close-btn" onClick={onClose}>×</button>
          </div>
        </div>
        
        <div className="calendar-full-view">
          <div className="calendar-days-grid">
            {diasSemana.map(d => (
              <div key={d} className="calendar-day-name">{d}</div>
            ))}
          </div>
          
          <div className="calendar-body-grid">
            {renderCalendar()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarioCobrancasModal;
